<template>
    <zk-admin-table title="精准关怀体检审核" :loading="loading" :table="table" @change="handleTableChange">
        <template v-slot:buttons>
            <el-row style="float: right">
                <el-button type="default" size="small" @click="getData" icon="el-icon-refresh">刷新</el-button>
            </el-row>
        </template>

        <template v-slot:search>
            <zk-search-form-inline :form="search" @search="getData">
                <el-form-item label="姓名">
                    <el-input v-model.trim="search.name" clearable style="width:120px"></el-input>
                </el-form-item>
                <el-form-item label="身份证号">
                    <el-input v-model.trim="search.id_card" clearable></el-input>
                </el-form-item>
                <el-form-item label="状态">
                     <el-select v-model="search.status" placeholder="全部" clearable style="width:120px">
                        <el-option label="已申请" value="0"></el-option>
                        <el-option label="已审核" value="1"></el-option>
                        <el-option label="审核不通过" value="-1"></el-option>
                        <el-option label="已收费" value="2"></el-option>
                    </el-select>
                </el-form-item>
            </zk-search-form-inline>
        </template>

        <el-table-column type="index" width="50" align="center" />
        <el-table-column prop="secondary_unit" label="二级单位" width="150" align="center" />
        <el-table-column prop="name" label="姓名" width="100" align="center" />
        <el-table-column prop="id_card" label="身份证号" width="170" align="center" />
        <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
                <el-tag v-if="scope.row.status == 0" type="primary" size="mini">已申请</el-tag>
                <el-tag v-else-if="scope.row.status == 1" type="success" size="mini">已审核</el-tag>
                <el-tag v-else-if="scope.row.status == -1" type="danger" size="mini">审核不通过</el-tag>
                <el-tag v-else-if="scope.row.status == 2" type="warning" size="mini">已收费</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="items" label="检查项目" align="center">
            <template slot-scope="scope">
                <el-tag v-for="(item, index) in scope.row.items" :key="index" size="mini" style="margin-right: 5px;">{{ item }}</el-tag>
            </template>
        </el-table-column>
        <el-table-column prop="total_cost" label="费用合计" width="100" align="center">
            <template slot-scope="scope">
                {{ scope.row.total_cost }} 元
            </template>
        </el-table-column>
        <el-table-column prop="create_time" label="申请时间" width="160" align="center" />
        <el-table-column prop="applicant" label="申请人" width="100" align="center" />
        
        <el-table-column align="center" width="120" label="操作" fixed="right">
            <template slot-scope="scope">
                <el-button size="mini" type="primary" @click="handleAudit(scope.row)" v-if="scope.row.status === 0">审核</el-button>
                <el-button size="mini" @click="handleAudit(scope.row)" v-else>查看</el-button>
            </template>
        </el-table-column>

        <template v-slot:dialog>
            <el-dialog title="审核申请" :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false">
                <el-form ref="form" :model="form" label-width="100px" disabled>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="姓名" prop="name">
                                <el-input v-model.trim="form.name"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="身份证号" prop="id_card">
                                <el-input v-model.trim="form.id_card"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="二级单位" prop="secondary_unit">
                                <el-input v-model.trim="form.secondary_unit"></el-input>
                            </el-form-item>
                        </el-col>
                         <el-col :span="12">
                             <el-form-item label="费用合计">
                                <span style="color: red; font-weight: bold; font-size: 16px;">{{ form.total_cost }} 元</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="检查项目" prop="items">
                                <el-tag v-for="(item, index) in form.items" :key="index" style="margin-right: 10px;">{{ item }}</el-tag>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <span slot="footer" class="dialog-footer" v-if="form.status === 0">
                    <el-button type="danger" @click="handleSubmit(-1)" :loading="loading">驳 回</el-button>
                    <el-button type="success" @click="handleSubmit(1)" :loading="loading">通 过</el-button>
                </span>
                <span slot="footer" class="dialog-footer" v-else>
                     <el-button @click="dialogVisible = false">关 闭</el-button>
                </span>
            </el-dialog>
        </template>
    </zk-admin-table>
</template>

<script>
export default {
    name: 'keycare_audit',
    path: '/main/keycare/audit',
    meta: {
        title: '精准关怀体检审核',
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            search: {
                name: '',
                id_card: '',
                status: '0' // Default to pending audit
            },
            table: {
                columns: [],
                data: [],
                total: 0,
                page: 1,
                pageSize: 20
            },
            form: {
                name: '',
                id_card: '',
                secondary_unit: '',
                items: [],
                total_cost: 0,
                status: 0
            }
        }
    },
    methods: {
        handleTableChange(e) {
            this.table = Object.assign({}, this.table, e);
            this.getData();
        },
        async getData() {
            this.loading = true;
            try {
                // Mock data
                const mockData = [
                    { 
                        id: 1, 
                        secondary_unit: '第一采油厂',
                        name: '张三', 
                        id_card: '110101199001011234', 
                        items: ['CTA', 'MRA'], 
                        total_cost: 2200,
                        status: 0,
                        applicant: '王五',
                        create_time: '2023-01-01 10:00:00'
                    },
                    { 
                        id: 2, 
                        secondary_unit: '第二采油厂',
                        name: '李四', 
                        id_card: '110101199202025678', 
                        items: ['心脏彩超'], 
                        total_cost: 300,
                        status: 1,
                        applicant: '赵六',
                        create_time: '2023-01-02 11:30:00',
                        audit_time: '2023-01-03 09:00:00',
                        auditor: '管理员'
                    }
                ];
                
                let filteredData = mockData.filter(item => {
                    let match = true;
                    if (this.search.name && !item.name.includes(this.search.name)) match = false;
                    if (this.search.id_card && !item.id_card.includes(this.search.id_card)) match = false;
                    if (this.search.status && item.status != this.search.status) match = false;
                    return match;
                });

                this.table.data = filteredData;
                this.table.total = filteredData.length;
                
            } catch (e) {
                this.$message.error(e.message || '获取数据失败');
            }
            this.loading = false;
        },
        handleAudit(row) {
            this.form = JSON.parse(JSON.stringify(row));
            this.dialogVisible = true;
        },
        async handleSubmit(status) {
            this.loading = true;
            try {
                // Mock audit submission
                // await this.$http.post('/keycare/audit', { id: this.form.id, status: status });
                
                await new Promise(resolve => setTimeout(resolve, 500)); 
                const msg = status === 1 ? '审核通过' : '审核驳回';
                this.$message.success(msg + ' (演示)');
                this.dialogVisible = false;
                this.getData();
            } catch (e) {
                this.$message.error(e.message || '操作失败');
            }
            this.loading = false;
        }
    },
    mounted() {
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
</style>
